/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import {ClaimsApi} from '../../../api/ms-claims/claims.api';
import {LoadingService} from '../../../shared/loading/loading-service/loading.service';
import {Observable} from 'rxjs';
import {finalize} from 'rxjs/operators';
import {ClaimDetailModel} from '../../../api/ms-claims/contracts/claim-detail.model';

@Injectable({
    providedIn: 'root'
})
export class ClaimDetailResolver  {

    constructor(private claimApi: ClaimsApi, private loadingService: LoadingService) {
    }

    resolve(route: ActivatedRouteSnapshot): Observable<ClaimDetailModel> {
        this.loadingService.start();
        const claimNumber = route.params['claimNumber'];
        return this.claimApi.getClaimDetail(claimNumber).pipe(
            finalize(() => this.loadingService.stop())
        );
    }
}
